import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase/config";
import {
    collection,
    addDoc,
    onSnapshot,
    deleteDoc,
    doc,
    updateDoc,
    getDoc,
    serverTimestamp,
    orderBy,
    query
} from "firebase/firestore";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./CalendarPage.css";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import logo from "../assets/AcunMedya-Logo.png";


const getAuthEmail = () => {
    const user = auth.currentUser;
    if (!user) return "UNKNOWN";

    // 1️⃣ Direkt email (varsa)
    if (user.email) return user.email;

    // 2️⃣ Provider içinden email (Microsoft / Google vs.)v
    if (user.providerData && user.providerData.length > 0) {
        const providerEmail = user.providerData.find(p => p.email)?.email;
        if (providerEmail) return providerEmail;
    }

    // 3️⃣ Firestore fallback (son çare)
    return "UNKNOWN";
};




const handleExportPDF = async () => {
    const element = document.getElementById("calendarScrollX");

    if (!element) {
        alert("❌ 'calendarScrollX' elementi bulunamadı!");
        return;
    }





};



const getProjectDisplayName = (name) => {
    if (name.includes("Survivor")) return "SURVIVOR";
    if (name.includes("Exatlon") || name.includes("Exathlon")) {
        return name.includes("Greece") ? "EXATHLON" : "EXATLON";
    }
    return name;
};

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
const ymd = (d) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const isToday = (date) => {
    const today = new Date();
    return (
        date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth() &&
        date.getDate() === today.getDate()
    );
};




export default function CalendarPage({ user, readOnly = false }) {

    const emptyForm = {
        project: "",
        zone: "",
        location: "",
        code: "",
        endingCode: "",
        date: "",
        note: "",
        isDraft: false,
        timeOfDay: "DAY",
        gameOrder: 1,
        outOfHub: false,
        outOfHubLocation: "",
        isReality: false,
        gameType: "",

    };

    const [hideHeader, setHideHeader] = useState(false);
    const [activeButton, setActiveButton] = useState("twoweek");
    const [selectedProjectFilter, setSelectedProjectFilter] = useState("all")
    const [events, setEvents] = useState([]);
    const [showAddEvent, setShowAddEvent] = useState(false);
    const [openAddEventModal, setOpenAddEventModal] = useState(false);
    const [form, setForm] = useState(emptyForm);
    const [viewMode, setViewMode] = useState("twoweeks");


    // 🟢 Event modal için state'ler
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [copiedEvent, setCopiedEvent] = useState(null);
    const [bulkAction, setBulkAction] = useState(null);
    const [zones, setZones] = useState([]);

    const getZoneColors = (zoneName) => {
        const zone = zones.find(z => z.name === zoneName);

        if (!zone) {
            return { bg: "#bbb", fg: "#111" };
        }

        // Sarı için koyu yazı, diğerleri beyaz
        const isYellow = zone.color === "#FFCE12";

        return {
            bg: zone.color,
            fg: isYellow ? "#111" : "#fff"
        };
    };
    useEffect(() => {
        const q = query(collection(db, "zones"), orderBy("order", "asc"));
        const unsub = onSnapshot(q, (snap) => {
            setZones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);

    const handleDeleteEvent = async (id) => {
        if (!window.confirm("⚠️ Are you sure you want to delete this event?")) return;

        try {
            let reason = "";
            while (!reason) {
                reason = prompt("Please enter the reason for deleting this event:");
                if (reason === null) return;
                if (!reason.trim()) alert("Reason is required.");
            }

            const ref = doc(db, "events", id);
            const snapshot = await getDoc(ref);
            if (!snapshot.exists()) return;

            const oldEvent = snapshot.data();

            await deleteDoc(ref);

            // ✅ DOĞRU DELETE LOG
            await addDoc(collection(db, "changeLogs"), {
                eventId: id,
                project: oldEvent.project,
                zone: oldEvent.zone,
                location: oldEvent.location,

                oldDate: oldEvent.date,
                oldGameType: oldEvent.gameType || null,

                description: "Event deleted",
                reason,
                user: getAuthEmail(),
                time: serverTimestamp(),
                status: "Deleted",
                isReality: oldEvent.isReality || false,
            });

            setSelectedEvent(null);
            alert("🗑️ Event deleted and logged successfully!");
        } catch (error) {
            console.error(error);
            alert("❌ Delete failed");
        }
    };


    // 🟢 Kart tıklanınca modal aç
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [selectionMode, setSelectionMode] = useState(false);

    const handleOpenEvent = (ev, e) => {
        // 🟢 CTRL (Windows) veya CMD (Mac) ile çoklu seçim
        if (e?.ctrlKey || e?.metaKey) {
            setSelectedEvents(prev =>
                prev.includes(ev.id)
                    ? prev.filter(id => id !== ev.id)
                    : [...prev, ev.id]
            );
            return; // ❗ modal açma
        }

        // 🟢 Eğer çoklu seçim varsa, tek tık modal açmasın
        if (selectedEvents.length > 0) {
            setSelectedEvents([ev.id]); // istersen sadece seçsin
            return;
        }

        // 🟢 Normal davranış (modal aç)
        setSelectedEvent(ev);
    };


    const exportFullCalendarPDF = async () => {
        const element = document.getElementById("calendarScrollX");
        if (!element) return alert("Takvim bulunamadı!");

        element.scrollTo(0, 0);

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
            windowWidth: element.scrollWidth,
            windowHeight: element.scrollHeight,
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF({
            orientation: "landscape",
            unit: "px",
            format: [canvas.width, canvas.height],
        });

        pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

        // 🌎 Dominik Cumhuriyeti saat dilimi
        const now = new Date();
        const options = {
            timeZone: "America/Santo_Domingo",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };

        const formatter = new Intl.DateTimeFormat("en-GB", options);
        const parts = formatter.formatToParts(now);
        const dateObj = Object.fromEntries(parts.map((p) => [p.type, p.value]));
        const fileName = `ACM-Games-Schedule_${dateObj.year}-${dateObj.month}-${dateObj.day}_${dateObj.hour}-${dateObj.minute}.pdf`;

        pdf.save(fileName);
    };

    // 🟢 Etkinliği güncelle (tarih/note revize edildiğinde)
    const handleSaveRevisedEvent = async () => {
        if (!selectedEvent) return;

        try {

            let reason = "";
            while (!reason) {
                reason = prompt("Please enter the reason for this revision:");
                if (reason === null) return;
                if (!reason.trim()) alert("Reason is required to log the change.");
            }



            const ref = doc(db, "events", selectedEvent.id);
            const oldEvent = events.find((e) => e.id === selectedEvent.id);

            // ✅ First update event
            await updateDoc(ref, {
                project: selectedEvent.project,
                zone: selectedEvent.zone,
                location: selectedEvent.location,
                date: selectedEvent.date,
                gameCode: selectedEvent.gameCode || "",
                endingCode: selectedEvent.endingCode || "",
                note: selectedEvent.note || "",
                timeOfDay: selectedEvent.timeOfDay || "DAY",
                gameOrder: selectedEvent.gameOrder || 1,

                gameType: selectedEvent.gameType || null,

                isRevised: true,
                revisedAt: serverTimestamp(),
                revisedBy: getAuthEmail(),
            });



            // ✅ Then write clean changeLog entry
            await addDoc(collection(db, "changeLogs"), {
                eventId: selectedEvent.id,
                project: selectedEvent.project,
                zone: selectedEvent.zone,
                location: selectedEvent.location,
                oldDate: oldEvent?.date,
                newDate: selectedEvent.date,
                reason,
                user: getAuthEmail(),
                time: serverTimestamp(),
                status: "Updated",

                // 🔥 KRİTİK
                isReality: selectedEvent.isReality || false
            });


            setEvents((prev) =>
                prev.map((ev) =>
                    ev.id === selectedEvent.id
                        ? { ...ev, isRevised: true, revisedBy: user?.email, revisedAt: new Date() }
                        : ev
                )
            );

            alert("✅ Event updated and logged to Change Logs!");
            setSelectedEvent(null);

        } catch (err) {
            console.error("Revision Error:", err);
            alert("❌ Error while saving revision: " + err.message);
        }
    };




    // 🟢 Kopyala
    const handleCopyEvent = () => {
        setCopiedEvent(selectedEvent);
        alert("Event copied! Click another date to paste.");
        setSelectedEvent(null);
    };



    /* Firestore listener */
    useEffect(() => {
        const unsub = onSnapshot(collection(db, "events"), (snap) => {
            setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);



    /* Tarih aralığı */
    const days = useMemo(() => {
        const today = new Date();
        const start = new Date(today);
        const end = new Date(today);
        if (viewMode === "week") {
            start.setDate(today.getDate() - 1);
            end.setDate(today.getDate() + 7);
        } else {
            start.setDate(today.getDate() - 21);
            end.setDate(today.getDate() + 14);
        }
        const arr = [];
        const cursor = new Date(start);
        while (cursor <= end) {
            arr.push(new Date(cursor));
            cursor.setDate(cursor.getDate() + 1);
        }
        return arr;
    }, [viewMode]);

    /* Event ekleme */
    const handleAddEvent = async (e) => {
        e.preventDefault();

        if (!form.project || !form.date) return alert("Project and Date required");

        // BLACK BOX + AMPHIBIOUS + SLIPPERRY
        if (form.date && form.location && !pendingFormSubmit) {
            const special = ["BLACK BOX", "AMPHIBIOUS", "SLIPPERRY"];

            if (special.includes(form.location)) {
                const conflict = events.find(ev =>
                    ev.date === form.date &&
                    special.includes(ev.location) &&
                    ev.location !== form.location
                );

                if (conflict) {
                    setZoneConflict({
                        date: form.date,
                        zone: "SPECIAL LOCATIONS",
                        countries: [`${conflict.project} (${conflict.location})`],
                        type: "SPECIAL_PARKOUR_CONFLICT"
                    });
                    return;
                }
            }
        }


        // ZONE conflict
        if (form.zone && form.date && !pendingFormSubmit) {
            const conflicts = events.filter(ev =>
                ev.date === form.date &&
                ev.zone === form.zone &&
                ev.project !== form.project
            );
            if (conflicts.length) {
                setZoneConflict({
                    date: form.date,
                    zone: form.zone,
                    countries: [...new Set(conflicts.map(e => e.project))]
                });
                return;
            }
        }

        try {
            const newEventRef = await addDoc(collection(db, "events"), {
                project: form.project,
                zone: form.zone || "",
                location: form.location || form.outOfHubLocation || "",
                gameCode: form.code || "",
                endingCode: form.endingCode || "",
                date: form.date,
                note: form.note || "",
                timeOfDay: form.timeOfDay,
                gameOrder: form.gameOrder,
                gameType: form.gameType, // ✅ EKLENDİ
                user: getAuthEmail(),

                createdAt: serverTimestamp(),
                isDraft: form.isDraft || false,
                outOfHub: form.outOfHub || false,
                isReality: form.isReality || false,
            });

            await addDoc(collection(db, "changeLogs"), {
                eventId: newEventRef.id,
                project: form.project,
                zone: form.zone || "",
                location: form.location || form.outOfHubLocation || "",
                oldDate: "(none)",
                newDate: form.date,
                reason: form.isReality ? "Reality day created" : "New event created",
                user: getAuthEmail(),
                time: serverTimestamp(),
                status: "Created",
                isReality: form.isReality || false
            });

            // ... devam


            setForm({
                project: "",
                zone: "",
                location: "",
                code: "",
                date: "",
                note: "",
                endingCode: "",
                outOfHub: false,
                outOfHubLocation: "",
                isReality: false,
                isDraft: false,
                timeOfDay: "DAY",
                gameOrder: 1,
                gameType: "",
            });


            setZoneConflict(null);
            setPendingFormSubmit(false);
            setShowAddEvent(false);
            alert("✅ Event successfully added!");

        } catch (err) {
            alert("❌ Error adding event");
        }
    };








    /* Drag & Drop */
    const onDragStart = (e, ev) => {
        e.dataTransfer.setData("application/json", JSON.stringify(ev));
    };


    const onDropToCell = async (e, dateStr, project) => {
        e.preventDefault();



        /* =========================
       🔥 BULK COPY / MOVE
    ========================= */
        if (bulkAction && selectedEvents.length > 0) {
            const confirmText =
                bulkAction === "copy"
                    ? `Copy ${selectedEvents.length} events to ${dateStr}?`
                    : `Move ${selectedEvents.length} events to ${dateStr}?`;

            if (!window.confirm(confirmText)) return;

            let reason = "";
            while (!reason) {
                reason = prompt("Please enter the reason for this bulk action:");
                if (reason === null) return;
                if (!reason.trim()) alert("Reason is required.");
            }

            const affectedEvents = events.filter(ev =>
                selectedEvents.includes(ev.id)
            );

            // 🧾 BULK SUMMARY LOG (ÖNCE)
            const bulkLogRef = await addDoc(collection(db, "changeLogs"), {
                type: "BULK",
                bulk: true,
                action: bulkAction.toUpperCase(),
                count: affectedEvents.length,
                eventIds: selectedEvents,
                targetDate: dateStr,
                targetProject: project,
                description: `${affectedEvents.length} events ${bulkAction === "copy" ? "COPIED" : "MOVED"
                    } to ${project} - ${dateStr}`,
                reason,
                user: getAuthEmail(),
                time: serverTimestamp(),
                status: bulkAction === "copy" ? "Bulk Copied" : "Bulk Moved",
            });

            // 🔁 EVENT BAZLI İŞLEMLER
            for (const ev of affectedEvents) {

                // 📄 COPY
                if (bulkAction === "copy") {
                    const copy = { ...ev };
                    delete copy.id;

                    const newRef = await addDoc(collection(db, "events"), {
                        ...copy,
                        date: dateStr,
                        project,
                        createdAt: serverTimestamp(),
                        isRevised: false,
                    });

                    await addDoc(collection(db, "changeLogs"), {
                        type: "EVENT",
                        bulk: true,
                        parentBulkId: bulkLogRef.id,
                        eventId: newRef.id,
                        project,
                        zone: ev.zone,
                        location: ev.location,
                        oldDate: ev.date,
                        newDate: dateStr,
                        oldGameType: draggedEvent.gameType || null,
                        isReality: draggedEvent.isReality || false,
                        description: "Event copied via BULK operation",
                        reason,
                        user: getAuthEmail(),
                        time: serverTimestamp(),
                        status: "Created",
                    });
                }

                // 🚚 MOVE
                if (bulkAction === "move") {
                    await updateDoc(doc(db, "events", ev.id), {
                        date: dateStr,
                        project,
                        isRevised: true,
                        revisedAt: serverTimestamp(),
                        revisedBy: getAuthEmail(),
                    });

                    await addDoc(collection(db, "changeLogs"), {
                        type: "EVENT",
                        bulk: true,
                        parentBulkId: bulkLogRef.id,
                        eventId: ev.id,
                        project,
                        zone: ev.zone,
                        location: ev.location,
                        oldDate: ev.date,
                        newDate: dateStr,
                        oldGameType: draggedEvent.gameType || null,
                        isReality: draggedEvent.isReality || false,
                        description: "Event moved via BULK operation",
                        reason,
                        user: getAuthEmail(),
                        time: serverTimestamp(),
                        status: "Updated",
                    });
                }
            }

            // 🧹 RESET
            setSelectedEvents([]);
            setBulkAction(null);
            setSelectionMode(false);

            alert("Bulk operation completed successfully!");
            return; // ⛔ SINGLE DROP'A DÜŞMESİN
        }



        /* =========================
           ⬇️ ESKİ SINGLE DRAG & DROP
        ========================= */
        const raw = e.dataTransfer.getData("application/json");
        if (!raw) return;

        const draggedEvent = JSON.parse(raw);

        const id = draggedEvent.id;
        const oldDate = draggedEvent.date;
        const zone = draggedEvent.zone;
        const location = draggedEvent.location;
        const oldUser = draggedEvent.user;


        if (oldDate === dateStr) return;

        const confirmMove = window.confirm(
            `Move event "${zone} / ${location}" to ${project} - ${dateStr}?`
        );
        if (!confirmMove) return;

        let reason = "";
        while (!reason) {
            reason = prompt("Please enter the reason for this change:");
            if (reason === null) return;
            if (!reason.trim()) alert("Reason is required.");
        }

        await updateDoc(doc(db, "events", id), {
            date: dateStr,
            project,
            isRevised: true,
            revisedAt: serverTimestamp(),
            revisedBy: user?.email || "UNKNOWN",
        });

        await addDoc(collection(db, "changeLogs"), {
            project,
            zone,
            location,
            oldDate,
            newDate: dateStr,
            oldGameType: draggedEvent.gameType || null,
            isReality: draggedEvent.isReality || false,
            reason,
            user: user?.email || oldUser || "UNKNOWN",
            time: serverTimestamp(),
            status: "Updated",
        });

        alert("Event moved successfully and logged in Change Logs.");
    };


    useEffect(() => {
        if (showAddEvent) {
            document.body.style.overflow = "hidden"; // Modal açıkken arka plan scroll yok
        } else {
            document.body.style.overflow = ""; // Modal kapalı → scroll serbest
        }
    }, [showAddEvent]);

    const navigate = useNavigate();


    useEffect(() => {
        const isMobile = () => window.innerWidth <= 768;
        if (!isMobile()) return;

        const scrollArea = document.querySelector("#calendarScrollX") || window;
        let lastScrollY = scrollArea === window ? window.scrollY : scrollArea.scrollTop;

        const updateTopGap = () => {
            const controls = document.querySelector(".calendar-controls-wrapper");
            const controlsBottom = controls?.getBoundingClientRect().bottom ?? 60;
            document.documentElement.style.setProperty("--top-gap", `${controlsBottom + 10}px`);
        };

        const handleScroll = () => {
            const currentScroll = scrollArea === window ? window.scrollY : scrollArea.scrollTop;

            if (currentScroll > lastScrollY && currentScroll > 50) {
                setHideHeader(true);
            } else if (currentScroll <= 10) {   // ✅ sadece en üste gelince geri gelsin
                setHideHeader(false);
            }

            lastScrollY = currentScroll;
            updateTopGap();   // ✅ kritik ekleme
        };

        scrollArea.addEventListener("scroll", handleScroll);
        return () => scrollArea.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const todayIndex = days.findIndex(d => isToday(d));
        if (todayIndex < 0) return;

        const cellWidth = 140;
        const scrollX = todayIndex * cellWidth;

        const el = document.getElementById("calendarScrollX");
        el?.scrollTo({ left: scrollX - 300, behavior: "smooth" });
    }, [days]);

    const [projectList, setProjectList] = useState([]);
    useEffect(() => {
        const q = query(collection(db, "projects"), orderBy("order", "asc"));
        const unsub = onSnapshot(q, (snap) => {
            setProjectList(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);




    const [zoneConflict, setZoneConflict] = useState(null);
    const [pendingFormSubmit, setPendingFormSubmit] = useState(false);


    const CELL_WIDTH = 140;
    useEffect(() => {
        console.log(
            "DAYS:", days.length,
            "FROM:", ymd(days[0]),
            "TO:", ymd(days[days.length - 1])
        );
    }, [days]);
    return (

        <div style={{ textAlign: "center", paddingBottom: 40 }}>

            {/* === HEADER === */}
            <header
                className={`mobile-header-admin ${hideHeader ? "hide" : ""}`}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    padding: "8px 12px",
                    flexWrap: "wrap",
                    zIndex: 2000,
                    top: 0,
                    left: 0,
                    width: "100%",
                    position: "fixed"
                }}
            >
                <img
                    src={logo}
                    alt="Acun Medya"
                    className="header-logo"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/calendar")}
                />
                <button
                    className="logout-modern"
                    onClick={() => {
                        signOut(auth)
                            .then(() => navigate("/login"))
                            .catch((err) => console.error("❌ Logout error:", err));
                    }}
                    title="Logout"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                    >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                </button>

                <nav className="header-tabs">
                    <button className="tab-btn" onClick={() => navigate("/admin")}>
                        CALENDAR
                    </button>
                    <button className="tab-btn" onClick={() => navigate("/changelogs")}>
                        CHANGES
                    </button>
                    <button className="tab-btn" onClick={() => navigate("/allevents")}>
                        EVENTS
                    </button>

                </nav>

                <div className="header-user">
                    <span>{user?.email?.toUpperCase()}</span>

                </div>
            </header>

            {/* === BUTONLAR === */}
            <div
                className="calendar-controls-wrapper"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 10,
                    flexWrap: "wrap",
                    marginBottom: 20,
                    position: "relative",
                    zIndex: 1500,
                    marginTop: hideHeader ? 10 : 120,
                }}
            >
                {user && !readOnly && (
                    <button
                        onClick={() => {
                            setForm(emptyForm);
                            setShowAddEvent(true);
                            setActiveButton("add");
                        }}
                        style={{
                            background: viewMode === "add" ? "#6c757d" : "#e0e0e0",
                            color: viewMode === "add" ? "white" : "black",
                            fontWeight: "bold",
                            border: "none",
                            padding: "10px 18px",
                            borderRadius: 8,
                            cursor: "pointer",
                        }}
                    >
                        ➕ ADD EVENT
                    </button>
                )}

                <button
                    onClick={() => setViewMode("week")}
                    style={{
                        background: viewMode === "week" ? "#6c757d" : "#e0e0e0",
                        color: viewMode === "week" ? "white" : "black",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: 8,
                        cursor: "pointer",
                    }}
                >
                    1 WEEK
                </button>

                <button
                    onClick={() => setViewMode("twoweeks")}
                    style={{
                        background: viewMode === "twoweeks" ? "#6c757d" : "#e0e0e0",
                        color: viewMode === "twoweeks" ? "white" : "black",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: 8,
                        cursor: "pointer",
                    }}
                >
                    5 WEEKS
                </button>

                <button
                    onClick={exportFullCalendarPDF}
                    style={{
                        background: "#f8f9fa",
                        color: "#000",
                        fontWeight: 600,
                        padding: "6px 12px",
                        borderRadius: 6,
                        border: "1px solid #ccc",
                        cursor: "pointer",
                        fontSize: 12,
                    }}
                >
                    📄 EXPORT PDF
                </button>
            </div>



            {/* === EVENT EKLEME === */}
            {showAddEvent && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.55)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: 12,
                            padding: "18px 20px",
                            maxHeight: "90vh",
                            width: "500px",
                            overflowY: "auto",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.35)",
                            animation: "popupEase .15s ease-out",
                            position: "relative",
                        }}
                    >
                        {/* X (kapat) butonu */}
                        <button
                            type="button"
                            onClick={() => setShowAddEvent(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 12,
                                background: "transparent",
                                border: "none",
                                fontSize: 22,
                                fontWeight: "bold",
                                cursor: "pointer",
                                color: "#000",
                            }}
                        >
                            ✕
                        </button>

                        {/* === EVENT EKLEME FORMUN === */}
                        <form onSubmit={handleAddEvent} style={{ width: "100%" }}>

                            {/* === PROJECT === */}
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                PROJECT <span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                                value={form.project}
                                onChange={(e) => setForm({ ...form, project: e.target.value })}
                                style={{
                                    padding: "8px 10px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    width: "100%"
                                }}
                            >
                                <option value="">Select Project</option>
                                {projectList.map((p) => (
                                    <option key={p.id} value={p.name}>
                                        {p.name}
                                    </option>
                                ))}
                            </select>

                            {/* === Eğer Reality aktif değilse geri kalan alanlar gösterilecek === */}
                            {!form.isReality && (
                                <>
                                    {/* === ZONE === */}
                                    <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                        ZONE{" "}
                                        {!form.outOfHub && (
                                            <span style={{ color: "red" }}>*</span>
                                        )}
                                    </label>
                                    <select
                                        value={form.zone}
                                        onChange={(e) => setForm({ ...form, zone: e.target.value })}
                                        disabled={form.outOfHub}
                                        style={{
                                            width: "100%",
                                            padding: "9px 8px",
                                            fontSize: 13.5,
                                            borderRadius: 6,
                                            marginBottom: 8,
                                            backgroundColor: form.outOfHub ? "#f1f1f1" : "white",
                                            cursor: form.outOfHub ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        <option value="">Select Zone</option>
                                        {zones.map((z) => (
                                            <option key={z.id} value={z.name}>
                                                {z.name}
                                            </option>
                                        ))}

                                    </select>

                                    {/* === LOCATION === */}
                                    <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                        LOCATION{" "}
                                        {!form.outOfHub && (
                                            <span style={{ color: "red" }}>*</span>
                                        )}
                                    </label>
                                    <select
                                        value={form.location}
                                        onChange={(e) => setForm({ ...form, location: e.target.value })}
                                        disabled={form.outOfHub}
                                        style={{
                                            width: "100%",
                                            padding: "9px 8px",
                                            fontSize: 13.5,
                                            borderRadius: 6,
                                            marginBottom: 8,
                                            backgroundColor: form.outOfHub ? "#f1f1f1" : "white",
                                            cursor: form.outOfHub ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        <option value="">Select Location</option>
                                        {form.zone &&
                                            zones
                                                .find(z => z.name === form.zone)
                                                ?.locations.map((loc) => (
                                                    <option key={loc} value={loc}>
                                                        {loc}
                                                    </option>
                                                ))}

                                    </select>

                                    {/* === OUT OF HUB === */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 10,
                                            padding: "10px 12px",
                                            borderRadius: 8,
                                            border: form.outOfHub ? "2px solid #007bff" : "1px solid #ccc",
                                            background: form.outOfHub
                                                ? "rgba(0,123,255,0.05)"
                                                : "#f9f9f9",
                                            transition: "all 0.3s ease",
                                            marginBottom: 8,
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={form.outOfHub || false}
                                            onChange={(e) =>
                                                setForm({ ...form, outOfHub: e.target.checked })
                                            }
                                            style={{ width: 18, height: 18, cursor: "pointer" }}
                                        />
                                        <span
                                            style={{
                                                fontWeight: 600,
                                                color: form.outOfHub ? "#007bff" : "#333",
                                            }}
                                        >
                                            Out of Hub (Special Location)
                                        </span>
                                        {form.outOfHub && (
                                            <span style={{ fontSize: 18, color: "#007bff" }}>📍</span>
                                        )}
                                    </div>

                                    {form.outOfHub && (
                                        <div style={{ animation: "fadeIn 0.3s ease", marginBottom: 8 }}>
                                            <input
                                                type="text"
                                                placeholder="Specify custom location (e.g. Beach Set, Hotel, Offsite...)"
                                                value={form.outOfHubLocation || ""}
                                                onChange={(e) =>
                                                    setForm({ ...form, outOfHubLocation: e.target.value })
                                                }
                                                style={{
                                                    width: "100%",
                                                    padding: "9px 8px",
                                                    fontSize: 13.5,
                                                    borderRadius: 6,
                                                    border: "1px solid #bbb",
                                                }}
                                            />
                                        </div>
                                    )}

                                    {/* === PROJECT CODE + ENDING CODE === */}
                                    <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                                PROJECT CODE <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="E.g. G3XX"
                                                value={form.code}
                                                onChange={(e) => setForm({ ...form, code: e.target.value })}
                                                style={{
                                                    width: "100%",
                                                    padding: "9px 8px",
                                                    fontSize: 13.5,
                                                    borderRadius: 6,
                                                }}
                                            />
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                                ENDING CODE
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="E.g. E-12"
                                                value={form.endingCode || ""}
                                                onChange={(e) => setForm({ ...form, endingCode: e.target.value })}
                                                style={{
                                                    width: "100%",
                                                    padding: "9px 8px",
                                                    fontSize: 13.5,
                                                    borderRadius: 6,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* === DATE === */}
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                DATE <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="date"
                                value={form.date}
                                onChange={(e) => setForm({ ...form, date: e.target.value })}
                                style={{
                                    width: "100%",
                                    padding: "12px 8px",
                                    fontSize: 14,
                                    borderRadius: 6,
                                    marginBottom: 8,
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                }}
                            />

                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                TIME OF DAY
                            </label>

                            <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                                <button
                                    type="button"
                                    onClick={() => setForm({ ...form, timeOfDay: "DAY" })}
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        borderRadius: 8,
                                        border: "1px solid #ccc",
                                        background: form.timeOfDay === "DAY" ? "#ffc107" : "#f1f1f1",
                                        fontWeight: 700,
                                        cursor: "pointer"
                                    }}
                                >
                                    🌞 DAY
                                </button>

                                <button
                                    type="button"
                                    onClick={() => setForm({ ...form, timeOfDay: "NIGHT" })}
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        borderRadius: 8,
                                        border: "1px solid #ccc",
                                        background: form.timeOfDay === "NIGHT" ? "#343a40" : "#f1f1f1",
                                        color: form.timeOfDay === "NIGHT" ? "#fff" : "#000",
                                        fontWeight: 700,
                                        cursor: "pointer"
                                    }}
                                >
                                    🌙 NIGHT
                                </button>
                            </div>

                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                GAME TYPE
                            </label>

                            <select
                                value={form.gameType}
                                onChange={(e) =>
                                    setForm({ ...form, gameType: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px 8px",
                                    fontSize: 13.5,
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                    cursor: "pointer",
                                }}
                            >
                                <option value=""></option>
                                <option value="IMMUNITY">IMMUNITY</option>
                                <option value="PERSONAL IMM">PERSONAL IMM</option>
                                <option value="DUEL">DUEL</option>
                                <option value="SUPPLY">SUPPLY</option>
                                <option value="REWARD">REWARD</option>
                            </select>


                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                GAME ORDER
                            </label>

                            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                                {[1, 2, 3].map((n) => (
                                    <button
                                        key={n}
                                        type="button"
                                        onClick={() => setForm({ ...form, gameOrder: n })}
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                            borderRadius: 8,
                                            border: "1px solid #ccc",
                                            background: form.gameOrder === n ? "#0d6efd" : "#f1f1f1",
                                            color: form.gameOrder === n ? "#fff" : "#000",
                                            fontWeight: 700,
                                            cursor: "pointer"
                                        }}
                                    >
                                        {n}. GAME
                                    </button>
                                ))}
                            </div>


                            {/* === REALITY CARD === */}
                            {form.isReality && (
                                <div
                                    style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        width: "120px",
                                        textAlign: "center",
                                        margin: "10px auto 12px",
                                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                                    }}
                                >
                                    <div style={{ background: "#000", height: "20px", width: "100%" }}></div>
                                    <div
                                        style={{
                                            padding: "6px 0",
                                            fontWeight: "700",
                                            fontSize: "18px",
                                            color: "#000",
                                            letterSpacing: "1px",
                                        }}
                                    >
                                        REALITY
                                    </div>
                                </div>
                            )}

                            {/* === NOTE (sadece Reality değilken) === */}
                            {!form.isReality && (
                                <>
                                    <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                        NOTE
                                    </label>
                                    <textarea
                                        value={form.note}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                note: e.target.value.toUpperCase(), // ✅ HER ZAMAN BÜYÜK HARF
                                            })
                                        }
                                        placeholder="Optional note..."
                                        style={{
                                            width: "100%",
                                            padding: "9px 8px",
                                            fontSize: 13,
                                            borderRadius: 6,
                                            height: 60,
                                            marginBottom: 8,
                                        }}
                                    />
                                </>
                            )}


                            {/* === BUTTONS === */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                {/* DRAFT BUTTON (her zaman görünür) */}
                                <button
                                    type="button"
                                    onClick={() => setForm({ ...form, isDraft: !form.isDraft })}
                                    style={{
                                        background: form.isDraft ? "#ffc107" : "#e9ecef",
                                        color: form.isDraft ? "#000" : "#444",
                                        border: "1px solid #ccc",
                                        padding: "8px 14px",
                                        borderRadius: 6,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        transition: "0.2s",
                                    }}
                                >
                                    {form.isDraft ? "✅ MARKED AS DRAFT" : "MARK AS DRAFT"}
                                </button>

                                {/* RIGHT BUTTON GROUP */}
                                <div style={{ display: "flex", gap: 8 }}>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setForm({ ...form, isReality: !form.isReality })
                                        }
                                        style={{
                                            background: form.isReality ? "#0d6efd" : "#e9ecef",
                                            color: form.isReality ? "#fff" : "#444",
                                            border: "1px solid #ccc",
                                            padding: "8px 14px",
                                            borderRadius: 6,
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            transition: "0.2s",
                                        }}
                                    >
                                        {form.isReality ? "🎬 REALITY DAY ON" : "SET REALITY DAY"}
                                    </button>

                                    <button
                                        type="submit"
                                        style={{
                                            background: "#007bff",
                                            color: "#fff",
                                            padding: "8px 16px",
                                            borderRadius: 6,
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: 600,
                                        }}
                                    >
                                        SAVE
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => setShowAddEvent(false)}
                                        style={{
                                            background: "#6c757d",
                                            color: "#fff",
                                            padding: "8px 16px",
                                            borderRadius: 6,
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: 600,
                                        }}
                                    >
                                        CANCEL
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* =========================
        BULK ACTION BAR
    ========================= */}
            {selectedEvents.length > 0 && (
                <div
                    style={{
                        position: "fixed",
                        bottom: 15,
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#343a40",
                        color: "#fff",
                        padding: "12px 16px",
                        borderRadius: 14,
                        display: "flex",
                        gap: 10,
                        zIndex: 10000,
                    }}
                >
                    <span>{selectedEvents.length} selected</span>

                    <button onClick={() => setBulkAction("copy")}>
                        📄 Copy & Drop
                    </button>

                    <button onClick={() => setBulkAction("move")}>
                        🚚 Move & Drop
                    </button>

                    <span style={{ fontSize: 12, opacity: 0.85 }}>
                        → Drop on target date
                    </span>
                    <button
                        onClick={() => {
                            setSelectedEvents([]);
                            setSelectionMode(false);
                        }}
                    >
                        ❌
                    </button>
                </div>
            )}



            {/* === TAKVİM === */}
            <div
                style={{
                    position: "relative",
                    borderRadius: 6,
                }}
            >
                {/* ◀ Sol kaydır butonu */}
                <button
                    onClick={() => {
                        document.getElementById("calendarScrollX").scrollBy({
                            left: -300,
                            behavior: "smooth",
                        });
                    }}
                    style={{
                        position: "absolute",
                        left: 5,
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "#343a40",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: 36,
                        height: 36,
                        cursor: "pointer",
                        opacity: 0.8,
                    }}
                >
                    ◀
                </button>

                {/* Takvim tablosu kaydırma alanı */}
                <div className="calendar-scroll">
                    <div id="calendarScrollX">

                        <table
                            style={{
                                borderCollapse: "collapse",

                                fontSize: 13,

                                width: days.length * CELL_WIDTH,
                            }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 10,

                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            position: "sticky",
                                            left: 0,
                                            top: 0,
                                            background: "#000000ff",
                                            color: "#fff",
                                            fontWeight: "900",
                                            textTransform: "uppercase",
                                            minWidth: 180,
                                            zIndex: 6,
                                            borderRight: "1px solid #999",
                                            letterSpacing: "0.8px",
                                            padding: 6,
                                        }}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                            <span style={{ fontSize: 12, textAlign: "center" }}>PROJECT / DATE</span>
                                            <select
                                                value={selectedProjectFilter}
                                                onChange={(e) => setSelectedProjectFilter(e.target.value)}
                                                style={{
                                                    fontSize: 12,
                                                    padding: "3px 4px",
                                                    borderRadius: 4,
                                                    border: "1px solid #666",
                                                    background: "#000000ff",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <option value="all">All Projects</option>
                                                <option value="Survivor">Survivor</option>
                                                <option value="Exatlon ">Exatlon</option>
                                            </select>
                                        </div>
                                    </th>
                                    {days.map((d) => {
                                        const isSunday = d.getDay() === 0;
                                        const today = isToday(d);

                                        return (
                                            <th
                                                key={ymd(d)}
                                                style={{
                                                    background: today
                                                        ? "#dc3545"        // 🔴 BUGÜN
                                                        : isSunday
                                                            ? "#fff3cd"        // 🟡 PAZAR
                                                            : "#000000",
                                                    color: today ? "#fff" : isSunday ? "#000" : "#fff",
                                                    fontWeight: today ? 900 : 800,
                                                    border: today ? "2px solid #b02a37" : "1px solid #999",
                                                    minWidth: 140,
                                                    padding: "8px 4px",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.3px",
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 5,
                                                }}
                                            >
                                                {d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })}
                                                <div style={{ fontSize: 11, opacity: 0.9 }}>
                                                    {d.toLocaleDateString("en-GB", { weekday: "short" }).toUpperCase()}
                                                </div>

                                                {today && (
                                                    <div style={{
                                                        fontSize: 10,
                                                        fontWeight: 700,
                                                        marginTop: 2,
                                                        letterSpacing: "0.5px"
                                                    }}>
                                                        TODAY
                                                    </div>
                                                )}
                                            </th>
                                        );
                                    })}



                                </tr>
                            </thead>
                            <tbody>
                                {projectList.filter((proj) =>
                                    selectedProjectFilter === "all"
                                        ? true
                                        : proj.name.toLowerCase().includes(selectedProjectFilter.toLowerCase())
                                ).map((proj) => (


                                    <tr key={proj.name}>
                                        {/* Sol sütun: Bayrak + Proje ismi */}
                                        <td
                                            style={{
                                                position: "sticky",
                                                left: 0,
                                                background: "rgb(213, 213, 213)",
                                                borderRight: "1px solid #999",
                                                minWidth: 130,
                                                zIndex: 4,
                                                textAlign: "center",
                                                padding: "10px 6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 8,
                                                }}
                                            >
                                                {/* Bayrak */}
                                                <img
                                                    src={proj.flag}
                                                    alt={`${proj.name} flag`}
                                                    style={{
                                                        width: 55,
                                                        height: 55,
                                                        borderRadius: "50%",
                                                        boxShadow: "0 0 8px rgba(0,0,0,0.4)",
                                                        objectFit: "cover",
                                                        background: "#fff",
                                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                        cursor: "pointer",
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = "scale(1.08)";
                                                        e.currentTarget.style.boxShadow = "0 0 12px rgba(0,0,0,0.6)";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = "scale(1)";
                                                        e.currentTarget.style.boxShadow = "0 0 8px rgba(0,0,0,0.4)";
                                                    }}
                                                />

                                                {/* Sadece Survivor veya Exathlon yazısı */}
                                                <span
                                                    style={{
                                                        fontWeight: 800,
                                                        fontSize: 15,
                                                        color: "#000",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.6px",
                                                    }}
                                                >
                                                    {getProjectDisplayName(proj.name)}
                                                </span>


                                            </div>
                                        </td>


                                        {/* Sağ taraf: Günlük hücreler */}
                                        {days.map((d) => {
                                            const dateStr = ymd(d);
                                            const todays = events
                                                .filter(ev => ev.project === proj.name && ev.date === dateStr)
                                                .sort((a, b) => {
                                                    const aTime = a.timeOfDay || "DAY";
                                                    const bTime = b.timeOfDay || "DAY";

                                                    if (aTime !== bTime) {
                                                        return aTime === "DAY" ? -1 : 1;
                                                    }

                                                    return (a.gameOrder || 1) - (b.gameOrder || 1);
                                                });



                                            // ✅ Pazar kontrolü ekledik
                                            const isSunday = d.getDay() === 0;
                                            const today = isToday(d);
                                            return (
                                                <td
                                                    key={proj.name + dateStr}
                                                    onDrop={(e) => onDropToCell(e, dateStr, proj.name)}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    style={{
                                                        border: today ? "2px solid #dc3545" : "1px solid #ccc",
                                                        minWidth: 140,
                                                        height: 110,
                                                        verticalAlign: "top",
                                                        background: today
                                                            ? "rgba(220,53,69,0.08)"   // 🔴 BUGÜN soft kırmızı
                                                            : isSunday
                                                                ? "#fff3cd"               // 🟡 PAZAR
                                                                : "#fff",
                                                    }}
                                                >


                                                    {todays.map((ev) => {
                                                        const { bg, fg } = getZoneColors(ev.zone);

                                                        const isSelected = selectedEvents.includes(ev.id);
                                                        let moved = false; // drag yapıldı mı kontrolü

                                                        let pressTimer = null;

                                                        return (

                                                            <div
                                                                key={ev.id}
                                                                draggable
                                                                onDragStart={(e) => {
                                                                    // ⛔ CTRL / CMD basılıyken drag tamamen iptal
                                                                    if (e.ctrlKey || e.metaKey) {
                                                                        e.preventDefault();
                                                                        return;
                                                                    }

                                                                    moved = true;
                                                                    e.dataTransfer.setData(
                                                                        "application/json",
                                                                        JSON.stringify(ev)
                                                                    );
                                                                }}
                                                                onDragEnd={() => (moved = false)}

                                                                onPointerDown={(e) => {
                                                                    // SADECE sol click
                                                                    if (e.button !== 0) return;

                                                                    if (e.ctrlKey || e.metaKey) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();

                                                                        setSelectedEvents(prev =>
                                                                            prev.includes(ev.id)
                                                                                ? prev.filter(id => id !== ev.id)
                                                                                : [...prev, ev.id]
                                                                        );
                                                                    }
                                                                }}

                                                                /* ===== MOBİL (LONG PRESS) ===== */
                                                                onTouchStart={() => {
                                                                    pressTimer = setTimeout(() => {
                                                                        setSelectionMode(true);
                                                                        setSelectedEvents(prev =>
                                                                            prev.includes(ev.id) ? prev : [...prev, ev.id]
                                                                        );
                                                                    }, 600);
                                                                }}

                                                                onTouchEnd={() => {
                                                                    clearTimeout(pressTimer);
                                                                }}

                                                                /* ===== ORTAK CLICK ===== */
                                                                onClick={(e) => {
                                                                    // CTRL ile click modal açmasın
                                                                    if (e.ctrlKey || e.metaKey) return;

                                                                    if (selectionMode) {
                                                                        setSelectedEvents(prev =>
                                                                            prev.includes(ev.id)
                                                                                ? prev.filter(id => id !== ev.id)
                                                                                : [...prev, ev.id]
                                                                        );
                                                                        return;
                                                                    }

                                                                    if (!moved) handleOpenEvent(ev, e);
                                                                }}

                                                                style={{
                                                                    background: "#fff",
                                                                    borderRadius: 10,
                                                                    marginBottom: 8,
                                                                    cursor: "grab",
                                                                    userSelect: "none",

                                                                    outline: isSelected ? "3px solid #0d6efd" : "none",
                                                                    boxShadow: isSelected
                                                                        ? "0 0 0 3px rgba(13,110,253,0.35)"
                                                                        : "0 2px 5px rgba(0,0,0,0.25)",
                                                                }}
                                                            >

                                                                {/* === REALITY KART === */}
                                                                {ev.isReality ? (
                                                                    <div
                                                                        style={{
                                                                            width: "100%",
                                                                            borderRadius: 8,
                                                                            overflow: "hidden",
                                                                            textAlign: "center",
                                                                            boxShadow: "0 2px 5px rgba(0,0,0,0.25)",
                                                                        }}
                                                                    >
                                                                        {/* Üst siyah şerit */}
                                                                        <div style={{ background: "#000", height: "22px", width: "100%" }}></div>

                                                                        {/* Orta “REALITY” yazısı */}
                                                                        <div
                                                                            style={{
                                                                                background: "#fff",
                                                                                color: "#000",
                                                                                fontWeight: 800,
                                                                                fontSize: 16,
                                                                                padding: "8px 0",
                                                                                letterSpacing: "1px",
                                                                            }}
                                                                        >
                                                                            REALITY
                                                                        </div>

                                                                        {/* Alt bilgi (not varsa gösterelim) */}
                                                                        {(ev.note || ev.endingCode) && (
                                                                            <div
                                                                                style={{
                                                                                    fontSize: 11.5,
                                                                                    marginTop: 2,
                                                                                    fontStyle: "italic",
                                                                                    opacity: 0.9,
                                                                                }}
                                                                            >
                                                                                {ev.note}
                                                                                {ev.endingCode && `  / ${ev.endingCode}`}
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        {/* === NORMAL EVENT === */}
                                                                        {/* ZONE Header */}
                                                                        <div
                                                                            style={{
                                                                                background: bg,
                                                                                color: fg,
                                                                                padding: "3px 6px",
                                                                                fontSize: 11,
                                                                                fontWeight: 800,
                                                                                textTransform: "uppercase",
                                                                                letterSpacing: "0.5px",
                                                                            }}
                                                                        >
                                                                            {ev.zone}
                                                                        </div>




                                                                        {/* 🕒 DAY / NIGHT + GAME ORDER */}
                                                                        <div
                                                                            style={{
                                                                                fontSize: 10,
                                                                                fontWeight: 700,
                                                                                padding: "2px 6px",
                                                                                background: ev.timeOfDay === "NIGHT" ? "#343a40" : "#ffc107",
                                                                                color: ev.timeOfDay === "NIGHT" ? "#fff" : "#000",
                                                                                letterSpacing: "0.4px",
                                                                            }}
                                                                        >
                                                                            {ev.timeOfDay === "NIGHT" ? "🌙 NIGHT" : "🌞 DAY"} · {ev.gameOrder}. GAME
                                                                        </div>
                                                                        {ev.gameType && (
                                                                            <div
                                                                                style={{
                                                                                    fontSize: 10,
                                                                                    fontWeight: 800,
                                                                                    padding: "2px 6px",
                                                                                    background: "#e9ecef",
                                                                                    color: "#000",
                                                                                    letterSpacing: "0.4px",
                                                                                    textTransform: "uppercase",
                                                                                }}
                                                                            >
                                                                                🎮 {ev.gameType}
                                                                            </div>
                                                                        )}




                                                                        {/* İçerik */}
                                                                        <div
                                                                            style={{
                                                                                padding: "8px 10px",
                                                                                fontSize: 12.5,
                                                                                lineHeight: 1.3,
                                                                            }}
                                                                        >
                                                                            <div style={{ fontWeight: 700 }}>{ev.location}</div>
                                                                            <div style={{ fontSize: 12, fontWeight: 700 }}>{ev.code}</div>
                                                                            {(ev.note || ev.endingCode) && (
                                                                                <div
                                                                                    style={{
                                                                                        fontSize: 11.5,
                                                                                        marginTop: 2,
                                                                                        fontStyle: "italic",
                                                                                        opacity: 0.9,
                                                                                    }}
                                                                                >
                                                                                    {ev.note}
                                                                                    {ev.endingCode && `  / ${ev.endingCode}`}
                                                                                </div>
                                                                            )}

                                                                        </div>

                                                                        {/* Footer etiketi (Draft / Revised) */}
                                                                        <div
                                                                            style={{
                                                                                borderTop: "1px solid #ccc",
                                                                                padding: "4px 6px",
                                                                                textAlign: "right",
                                                                            }}
                                                                        >
                                                                            {ev.isRevised ? (
                                                                                <span
                                                                                    style={{
                                                                                        background: "#dc3545",
                                                                                        color: "white",
                                                                                        fontSize: 10.5,
                                                                                        padding: "2px 6px",
                                                                                        borderRadius: 6,
                                                                                        fontWeight: 700,
                                                                                    }}
                                                                                >
                                                                                    REVISED
                                                                                </span>
                                                                            ) : ev.isDraft ? (
                                                                                <span
                                                                                    style={{
                                                                                        background: "#6c757d",
                                                                                        color: "white",
                                                                                        fontSize: 10.5,
                                                                                        padding: "2px 6px",
                                                                                        borderRadius: 6,
                                                                                        fontWeight: 700,
                                                                                    }}
                                                                                >
                                                                                    DRAFT
                                                                                </span>
                                                                            ) : null}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                        );
                                                    })}



                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>

                        </table>

                    </div>
                </div>

                {/* === MODAL === */}
                {selectedEvent && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.4)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                        }}
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: 20,
                                borderRadius: 10,
                                width: 400,
                                boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
                            }}
                        >
                            <h3 style={{ marginBottom: 10 }}>{selectedEvent.project}</h3>
                            {/* 🏷 ZONE */}
                            <label><b>Zone:</b></label>
                            <input
                                type="text"
                                value={selectedEvent.zone || ""}
                                onChange={(e) =>
                                    setSelectedEvent({ ...selectedEvent, zone: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    marginTop: 4,
                                    padding: "6px 8px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                }}
                            />

                            {/* 📍 LOCATION */}
                            <label><b>Location:</b></label>
                            <input
                                type="text"
                                value={selectedEvent.location || ""}
                                onChange={(e) =>
                                    setSelectedEvent({ ...selectedEvent, location: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    marginTop: 4,
                                    padding: "6px 8px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                }}
                            />


                            {/* 📅 Date */}
                            <label><b>Date:</b></label>
                            <input
                                type="date"
                                value={selectedEvent.date}
                                onChange={(e) =>
                                    setSelectedEvent({
                                        ...selectedEvent,
                                        date: e.target.value,
                                        isRevised: true,
                                    })
                                }
                                style={{
                                    width: "100%",
                                    marginTop: 4,
                                    padding: "6px 8px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                }}
                            />


                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                TIME OF DAY
                            </label>

                            <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                                <button
                                    type="button"
                                    onClick={() =>
                                        setSelectedEvent({
                                            ...selectedEvent,
                                            timeOfDay: "DAY",
                                            isRevised: true,
                                        })
                                    }
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        borderRadius: 8,
                                        border: "1px solid #ccc",
                                        background: selectedEvent.timeOfDay === "DAY" ? "#ffc107" : "#f1f1f1",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                    }}
                                >
                                    🌞 DAY
                                </button>

                                <button
                                    type="button"
                                    onClick={() =>
                                        setSelectedEvent({
                                            ...selectedEvent,
                                            timeOfDay: "NIGHT",
                                            isRevised: true,
                                        })
                                    }
                                    style={{
                                        flex: 1,
                                        padding: "10px",
                                        borderRadius: 8,
                                        border: "1px solid #ccc",
                                        background: selectedEvent.timeOfDay === "NIGHT" ? "#343a40" : "#f1f1f1",
                                        color: selectedEvent.timeOfDay === "NIGHT" ? "#fff" : "#000",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                    }}
                                >
                                    🌙 NIGHT
                                </button>
                            </div>
                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                GAME TYPE
                            </label>

                            <select
                                value={selectedEvent.gameType ?? ""}
                                onChange={(e) =>
                                    setSelectedEvent({
                                        ...selectedEvent,
                                        gameType: e.target.value,
                                        isRevised: true,
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px 8px",
                                    fontSize: 13.5,
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                }}
                            >
                                <option value=""></option>
                                <option value="IMMUNITY">IMMUNITY</option>
                                <option value="PERSONAL IMM">PERSONAL IMM</option>
                                <option value="DUEL">DUEL</option>
                                <option value="SUPPLY">SUPPLY</option>
                                <option value="REWARD">REWARD</option>
                            </select>


                            <label style={{ fontWeight: 600, marginBottom: 4 }}>
                                GAME ORDER
                            </label>

                            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                                {[1, 2, 3].map((n) => (
                                    <button
                                        key={n}
                                        type="button"
                                        onClick={() =>
                                            setSelectedEvent({
                                                ...selectedEvent,
                                                gameOrder: n,
                                                isRevised: true,
                                            })
                                        }
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                            borderRadius: 8,
                                            border: "1px solid #ccc",
                                            background:
                                                selectedEvent.gameOrder === n ? "#0d6efd" : "#f1f1f1",
                                            color:
                                                selectedEvent.gameOrder === n ? "#fff" : "#000",
                                            fontWeight: 700,
                                            cursor: "pointer",
                                        }}
                                    >
                                        {n}. GAME
                                    </button>
                                ))}
                            </div>




                            {/* 🎮 GAME CODE */}
                            <label style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
                                GAME CODE
                            </label>

                            <input
                                type="text"
                                value={selectedEvent.gameCode || selectedEvent.code || ""}
                                onChange={(e) =>
                                    setSelectedEvent({
                                        ...selectedEvent,
                                        gameCode: e.target.value.toUpperCase(),
                                        isRevised: true
                                    })
                                }
                                placeholder="Ex: G1-25"
                                style={{
                                    width: "100%",
                                    padding: "9px 8px",
                                    fontSize: 13.5,
                                    borderRadius: 6,
                                }}
                            />


                            {/* 🔢 Ending Code */}
                            <label><b>Ending Code:</b></label>
                            <input
                                type="text"
                                value={selectedEvent?.endingCode || ""}
                                onChange={(e) =>
                                    setSelectedEvent({
                                        ...selectedEvent,
                                        endingCode: e.target.value
                                    })
                                }
                                style={{
                                    width: "100%",
                                    marginTop: 4,
                                    padding: "6px 8px",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginBottom: 10,
                                }}
                                placeholder="Enter ending code..."
                            />

                            {/* 📝 Note */}
                            <label><b>Note:</b></label>
                            <textarea
                                value={selectedEvent.note}
                                onChange={(e) =>
                                    setSelectedEvent({
                                        ...selectedEvent,
                                        note: e.target.value.toUpperCase(), // ✅ HER ZAMAN BÜYÜK HARF
                                    })
                                }
                                style={{
                                    width: "100%",
                                    height: 60,
                                    resize: "none",
                                    borderRadius: 6,
                                    border: "1px solid #ccc",
                                    marginTop: 4,
                                    overflowY: "auto",
                                }}
                            />


                            {/* 🔘 Buttons */}
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 15 }}>
                                <button
                                    onClick={handleSaveRevisedEvent}
                                    style={{
                                        background: "#007bff",
                                        color: "white",
                                        border: "none",
                                        borderRadius: 6,
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Save
                                </button>
                                <button
                                    onClick={handleCopyEvent}
                                    style={{
                                        background: "#ffc107",
                                        color: "#000",
                                        border: "none",
                                        borderRadius: 6,
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Copy
                                </button>
                                <button
                                    onClick={() => handleDeleteEvent(selectedEvent.id)}
                                    style={{
                                        background: "#dc3545",
                                        color: "white",
                                        border: "none",
                                        borderRadius: 6,
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Delete
                                </button>
                                <button
                                    onClick={() => setSelectedEvent(null)}
                                    style={{
                                        background: "#6c757d",
                                        color: "white",
                                        border: "none",
                                        borderRadius: 6,
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {/* ▶ Sağ kaydır butonu */}
                <button
                    onClick={() => {
                        document.getElementById("calendarScrollX").scrollBy({
                            left: 300,
                            behavior: "smooth",
                        });
                    }}
                    style={{
                        position: "absolute",
                        right: 5,
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 10,
                        background: "#343a40",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: 36,
                        height: 36,
                        cursor: "pointer",
                        opacity: 0.8,
                    }}
                >
                    ▶
                </button>
                {/* === ZONE CONFLICT POPUP === */}
                {zoneConflict && (
                    <div
                        style={{
                            position: "fixed",
                            inset: 0,
                            background: "rgba(0,0,0,0.55)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 100000,
                        }}
                    >
                        <div
                            style={{
                                background: "#fff",
                                borderRadius: 14,
                                padding: "22px 24px",
                                width: 420,
                                boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
                                textAlign: "center",
                                animation: "popupEase .15s ease-out",
                            }}
                        >
                            <h3 style={{ marginBottom: 12 }}>⚠️ Zone Conflict</h3>

                            <p style={{ fontSize: 14, lineHeight: 1.5 }}>
                                A conflicting event already exists
                                <br />
                                for the <b>same day</b>.
                            </p>

                            <div
                                style={{
                                    marginTop: 12,
                                    marginBottom: 12,
                                    padding: 10,
                                    borderRadius: 8,
                                    background: "#f8f9fa",
                                    fontSize: 13,
                                }}
                            >
                                <div><b>Date:</b> {zoneConflict.date}</div>
                                <div><b>Zone:</b> {zoneConflict.zone}</div>
                                <div>
                                    <b>Existing Country(s):</b>
                                    <br />
                                    {zoneConflict.countries.join(", ")}
                                </div>
                            </div>

                            <p style={{ fontSize: 13, color: "#555" }}>
                                Do you want to continue anyway?
                            </p>

                            {zoneConflict.type === "SPECIAL_PARKOUR_CONFLICT" && (
                                <div
                                    style={{
                                        marginTop: 6,
                                        color: "#dc3545",
                                        fontWeight: 700,
                                        fontSize: 13,
                                    }}
                                >
                                    ⚠️ This parkour cannot be scheduled on the same day as another special parkour
                                    (BLACK BOX, AMPHIBIOUS, SLIPPERRY). Please select a different date or location.
                                </div>
                            )}



                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: 18,
                                }}
                            >
                                <button
                                    onClick={() => {
                                        setZoneConflict(null);
                                        setPendingFormSubmit(false);
                                    }}
                                    style={{
                                        background: "#6c757d",
                                        color: "#fff",
                                        border: "none",
                                        padding: "8px 18px",
                                        borderRadius: 8,
                                        cursor: "pointer",
                                        fontWeight: 600,
                                    }}
                                >
                                    ❌ Cancel
                                </button>

                                <button
                                    onClick={() => {
                                        setPendingFormSubmit(true);
                                        setZoneConflict(null);
                                        handleAddEvent(new Event("submit"));
                                    }}
                                    style={{
                                        background: "#dc3545",
                                        color: "#fff",
                                        border: "none",
                                        padding: "8px 18px",
                                        borderRadius: 8,
                                        cursor: "pointer",
                                        fontWeight: 600,
                                    }}
                                >
                                    ✅ Continue
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>

        </div>


    );
}


